export default __webpack_public_path__ + "static/media/producEau.4f68a15a.jpg";